export interface IBaseEnvironment {
  enableAngularProdMode: boolean;
  accessManagerUrl: string;
  baseDomain: string;
  backEndUrl: string;
  environmentName?: string;
}
